<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0" style="white-space: nowrap">
        <select-project
          v-if="!options.hideProjectSelector && !options.projectSearch"
          v-model="project"
          :class="{'report-base-filter': !options.multiple, 'report-multiple-combobox': options.multiple}"
          :multiple="options.multiple"
          single-line
          :show-select-all="options.showSelectAll"
          :style="{'min-width': '200px', 'max-width': options.multiple ?  '350px' : '230px'}"
        ></select-project>
        <v-text-field
          v-if="options.login"
          v-model="login"
          class="report-base-filter"
          hide-details
          label="Login"
          placeholder="Login with prefix, ex: TT_TEST"
        ></v-text-field>


        <v-select
          v-if="!options.hideDate"
          :items="dateRangeList"
          :value="dateRangeList[0]"
          class="report-base-filter"
          hide-details
          label="Period"
          style="min-width: 150px"
          v-on:change="changeTimePeriod"
        ></v-select>

        <v-checkbox
          v-if="options.byCountry"
          v-model="byCountry"
          class="mr-2"
          label="By country"
          style="max-width: 230px"
        />

        <template v-if="options.birthday">
          <v-row class="mx-0" style="max-width: 180px;">
            <v-row class="mx-0">
              <v-autocomplete v-model="month" :items="months" auto-select-first class="col-6 pl-0" hide-details label="Month" style="max-width: 50%;" />
              <v-autocomplete v-model="day" :items="days" auto-select-first class="col-6 pl-0" hide-details label="Day" style="max-width: 50%;" />
            </v-row>
          </v-row>
        </template>

        <date-picker
          v-if="!options.hideDate || options.singleDate"
          v-model="from"
          label="Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-if="!options.hideDate"
          v-model="to"
          label="Date To"
          style="max-width: 140px"
        />

        <v-btn-toggle
          v-if="options.typeCommission"
          v-model="defaultParams.type"
          class="mr-3 mt-3"
        >
          <v-btn color="blue lighten-3" small value="internal">
            Internal
          </v-btn>
          <v-btn color="blue lighten-3" small value="external">
            External
          </v-btn>
        </v-btn-toggle>

        <v-btn :disabled="loading" :loading="loading" class="mt-2" color="info" v-on:click="search">Search</v-btn>

        <v-btn
          v-if="socketAvailable && autoUpdate != -1"
          small
          class="mt-3 mx-3"
          color="info"
          icon
          @click="toggleSocketUpdate"
        >
          <v-icon>{{ socketUpdateIcon }}</v-icon>
          <v-badge
            style="margin-top: -15px"
            :content="pausedItems.length"
            :value="pausedItems.length"
          />
        </v-btn>

        <v-menu>
          <template #activator="{ on, attrs }">
            <v-btn
              class="align-self-center mx-3"
              v-on="on"
              v-bind="attrs"
              icon
              title="Number Formatting"
              color="primary"
            >
              <v-icon>
                mdi-decimal
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-subheader>
              Number formatting
            </v-subheader>

            <v-list-item
              v-for="formatter in FORMATTING_OPTIONS"
              :key="formatter.value"
              :input-value="localeFormatter === formatter.value"
              @click="onLocaleFormatterChange(formatter.value)"
            >
              <v-list-item-title v-text="formatter.text" />
            </v-list-item>
          </v-list>
        </v-menu>

        <export
          v-if="!options.hideExport"
          :data="filteredItems"
          :fields="exportFields"
          :project="project"
          :report="{url: url, from: from, to: to, ...defaultParams, ...tableOptions, entity_id: this.project}"
          :reportName="title"
        />

        <div class="col-2 pa-0" style="position: relative">
          <total-table-in-select
            v-if="options.totalsInHeader && options.totalCalculate"
            v-model="isTotalExtendOpen"
            :options="options"
            :totalByFiltredRows="totalByFiltredRows"
            :totalSubGroupByFiltredRows="totalSubGroupByFiltredRows"
            :totalTableHeader="totalTableHeader"
          />
        </div>
      </v-row>
      <v-row class="px-0 mx-0" justify="center">
        <v-autocomplete
          v-if="options.selectSystemBrand"
          v-model="tableOptions.system_alias"
          :items="providerSystemsAliases"
          :loading="loadingGames"
          class="pa-3"
          clearable
          hide-details
          label="Provider"
        />
        <v-autocomplete
          v-if="options.selectSystemBrand"
          v-model="tableOptions.brand_alias"
          :items="providerBrandsAliases"
          :loading="loadingGames"
          class="pa-3"
          clearable
          hide-details
          label="Brand"
        />
        <v-autocomplete
          v-if="options.selectGame"
          v-model="tableOptions.game_id"
          :items="filteredFreespinsGames"
          :loading="loadingGames"
          class="pa-3"
          clearable
          hide-details
          item-text="name"
          item-value="game_id"
          label="Game"
        >
          <template slot="item" slot-scope="{ item }">
            <div style="width: 100%">
              <span v-html="item.name"></span>
              <small class="float-right">({{ item.system_name }})</small>
            </div>
          </template>

        </v-autocomplete>
      </v-row>
      <v-row class="mx-2">

        <v-btn-toggle
          v-if="options.accountType"
          v-model="accountType"
          class="mr-3 mt-3"
          multiple
        >
          <v-btn color="blue lighten-3" small value="casino">
            Casino
          </v-btn>
          <v-btn color="blue lighten-3" small value="sport">
            Sport
          </v-btn>
          <v-btn v-if="get($store.state.auth, 'user.settings.type') == 'cashier' || get($store.state.auth, 'user.settings.type') == 'admin'" color="blue lighten-3" small value="cashier">
            Cashier
          </v-btn>
          <v-btn color="blue lighten-3" small value="test">
            Test
          </v-btn>
          <v-btn color="blue lighten-3" small value="affiliate">
            Aff
          </v-btn>
        </v-btn-toggle>
      </v-row>
    </v-card>


    <v-card class="col-12 pt-4 pb-4 px-0 mt-4">
      <v-data-table
        :class="{nowrap, 'table-size-fixed': table_size_fixed, 'report-dt': true}"
        :footer-props="{'items-per-page-options': options.perpage ? ( options.perpage_list || [30, 60, 90]) : [(filteredItems.length > 1000 ? 1000 : null) || -1]}"
        :headers="headers"
        :height="`calc(100vh - 165px - ${options.accountType  || options.login ? 40 : 0}px - ${options.selectGame || options.selectSystemBrand ? 60 : 0}px - ${!options.pagination && filteredItems.length < 1000 ? 0 : 40}px - ${!options.padding ? 0 : options.padding}px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        :hide-default-footer="!options.pagination && filteredItems.length < 1000"
        :item-key="options?.expand?.itemKey || undefined"
        :items="filteredItems"
        :items-per-page="options.perpage || (!options.perpage && filteredItems.length > 1000 ? 1000 : null) || -1"
        :loading="loading"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :show-expand="!!options.expand"
        :single-expand="options?.expand?.single"
        calculate-widths
        fixed-header
        sort-by="created"
        sort-desc
        style="z-index: 0; position: relative; width: 100%"
        @item-expanded="expandInit"
      >
        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length">
            <v-data-table
              v-if="subItems[item.row_key]"
              :headers="options.expand.headers"
              :items="filteredSubItems"
              :items-per-page="-1"
              :loading="subItems[item.row_key].loading"
              class="col-12 pa-0 report-expand-subdata"
              fixed-header
              height="300px"
              dense
              hide-default-footer
            >
              <template v-slot:body.prepend>
                <tr v-if="Object.keys(filtersOfExpandedTable).length > 0" class="report-filter-row grey lighten-3">
                  <td
                    v-for="header in options.expand.headers"
                    :key="header.text"
                  >
                    <v-text-field
                      v-if="filtersOfExpandedTable.hasOwnProperty(header.value) && filtersOfExpandedTable[header.value].type == 'text'"
                      v-model="filtersOfExpandedTable[header.value].data"
                      :style="{width: (filtersOfExpandedTable[header.value] || {width: false}).width}"
                      class="data-table-finance-filter-textfield"
                      hide-details
                    ></v-text-field>
                  </td>
                </tr>
              </template>

              <template v-slot:item.row_num="{ index }">
                <span>{{ index + 1 }}</span>
              </template>

            </v-data-table>
          </td>
        </template>
        <template
          v-for="header in headers"
          #[`item.${header.value}`]="{value}"
        >
          {{ fmtIntl(value) }}
        </template>
        <template v-slot:item.row_num="{ index }">
          <span>{{ index + 1 }}</span>
        </template>
        <template v-slot:item.login="{ item, header }">
          <a v-if="!item.total" :href="'/user-management/' + (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), ''))" target="_blank">{{ (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), '')) }}</a>
          <div v-if="item.total">Total:</div>
        </template>
        <template v-slot:item.account_id="{ item, header }">
          <a v-if="!item.total" :href="'/user-management/' + (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), ''))" target="_blank">{{ item.account_id }}</a>
        </template>
        <template v-slot:item.duplicates="{ item, header }">
          <span style="zoom: 0.8" v-html="duplicatesFlags(item.duplicates)"></span>
        </template>
        <template v-slot:item.doubles="{ item, header }">
          <span style="zoom: 0.8" v-html="duplicatesFlags(item.doubles)"></span>
        </template>
        <template v-slot:item.comment="{ item, header }">
          <div :style=" !header.style ? {'min-width': '250px', 'white-space': 'normal'} : header.style" v-html="$sanitize(item.comment)"></div>
        </template>
        <template v-slot:item.sid="{ item, header }">
          <div style="width: 70px; overflow: hidden" v-html="item.sid"></div>
        </template>
        <template v-slot:item.ip="{ item, header }">
          <div style="width: 120px; text-overflow: ellipsis; overflow: hidden" v-html="item.ip"></div>
        </template>
        <template v-slot:item.host="{ item, header }">
          <div :title="item.host" style="max-width: 150px; text-overflow: ellipsis; overflow: hidden" v-html="(item.host || '').replace('https://', '')"></div>
        </template>
        <!--        <template v-slot:item.total_bet="{ item, header }">-->
        <!--          {{ round(item.bet, 2) }} ({{ round(item.balance_bet, 2) }}/{{ round(item.bonus_bet, 2) }})-->
        <!--        </template>-->
        <!--        <template v-slot:item.total_win="{ item, header }">-->
        <!--          {{ round(item.win, 2) }} ({{ round(item.balance_win, 2) }}/{{ round(item.bonus_win, 2) }})-->
        <!--        </template>-->
        <template v-slot:item.houseearning_eur="{ item, header }">
          {{ 'houseearning_eur' in item ? item.houseearning_eur : (item.bet_eur - (item.win_eur - item.freespin_win_eur)).toFixed(0) }}
        </template>
        <template v-slot:item.netprofit_eur="{ item, header }">
          {{ 'netprofit_eur' in item ? item.netprofit_eur : (item.bet_eur - (item.win_eur - item.freespin_win_eur - item.correction_eur) - (item.bonus_deposit_eur - item.bonus_withdraw_eur)).toFixed(0) }}
        </template>
        <template v-slot:item.houseearning="{ item, header }">
          {{ 'houseearning' in item ? item.houseearning : (item.bet - (item.win - item.freespin_win)).toFixed(0) }}
        </template>
        <template v-slot:item.netprofit="{ item, header }">
          {{ 'netprofit' in item ? item.netprofit : (item.bet - (item.win - item.freespin_win - item.correction) - (item.bonus_deposit - item.bonus_withdraw)).toFixed(0) }}
        </template>
        <template v-slot:item.paymethods="{ item, header }">
          <div v-if="headers.length > 7" style="min-width: 250px; white-space: normal" v-html="item.paymethods"></div>
          <template v-else v-html="item.paymethods"></template>
        </template>
        <template v-slot:item.paymethod="{ item, header }">
          <div :style=" !header.style ? {'max-width': '150px', 'white-space': 'normal'} : header.style" v-html="item.paymethod"></div>
        </template>
        <template v-slot:item.request="{ item }">
          <pre style="white-space: pre-wrap">{{ JSON.stringify(JSON.parse(item.request), null, 4) }}</pre>
        </template>
        <template v-slot:item.response="{ item }">
          <pre style="white-space: pre-wrap">{{ JSON.stringify(JSON.parse(item.response), null, 4) }}</pre>
        </template>
        <template v-slot:item.affiliate.pid="{ item }">
          {{ item?.affiliate?.partner_id || item?.affiliate?.pid }}
        </template>

        <template v-slot:item.credit_eur="{ item }">
          <b v-if="item.credit_eur > 2000" class='warning--text'>{{ item.credit_eur }}</b>
          <template v-else>{{ item.credit_eur }}</template>
        </template>
        <template v-slot:item.additional_info="{ item }">
          <v-icon v-if="item.total_deposit_eur && item.total_deposit_eur > 2000" :title="`Warning: Total deposit: ${item.total_deposit_eur} EUR`" color="red" style="margin-top: -3px; width: 10px;">mdi-exclamation-thick</v-icon>
          <v-icon v-if="item.credit_eur && item.credit_eur > 2000" color="warning" style="margin-top: -3px;" title="Warning: Big deposit!">mdi-chevron-double-up</v-icon>
        </template>

        <template v-for="(h, k) of options.highlight || []" v-slot:[h.slot]="{ item }">
          <v-chip
            :color="item[k] == h.value ? 'green lighten-4' : 'red lighten-4'"
          >
            {{ item[h.field] }}
          </v-chip>
        </template>
        <template v-slot:item.iovation_state="{ item }">
          <v-chip
            v-if="item.iovation_state"
            :color="iovationColorMap[item.iovation_state]"
          >
            {{ item.iovation_state }}
          </v-chip>
        </template>
        <template v-slot:item.vip="{ item }">
          {{ item.vip ? 'Yes' : 'No' }}
        </template>

        <template v-slot:item.comment="{ item }">
          <template v-if="(item.comment || '').length <= 25">{{ item.comment }}</template>
          <div v-else style="min-width: 150px;max-width: 250px; white-space: normal;">{{ item.comment }}</div>
        </template>

        <template v-slot:body.prepend>
          <filter-table
            :columnValueList="columnValueList"
            :filters.sync="filters"
            :headers="headers"
          />
        </template>
        <template v-slot:body.append>
          <tr v-if="totalRow && items.length == filteredItems.length">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <b v-if="header.value === options?.totalCalculate?.titleField">Total</b>
              {{ totalRow[header.value] }}
            </td>
          </tr>

          <template v-if="totalRows">
            <total-filtered-rows
              v-for="row in filteredTotalRows"
              v-if="filteredTotalRows"
              :key="row.id"
              :headers="headers"
              :options="options"
              :rowData="row"
              :fmt="fmtIntl"
            />
          </template>

          <template v-if="!totalRows && !totalRow && options.totalCalculate">
            <total-calculate-sub
              v-for="row in totalSubGroupByFiltredRows"
              :key="row.id"
              :headers="headers"
              :options="options"
              :rowData="row"
              :fmt="fmtIntl"
            />
            <total-calculate-rows
              v-if="totalByFiltredRows"
              :headers="headers"
              :options="options"
              :rowData="totalByFiltredRows"
              :fmt="fmtIntl"
            />
          </template>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
  @import '@/assets/table/report-table.scss';
</style>

<script>
  import moment from 'moment'
  import { find, get, map, filter, round, debounce, range, includes, isArray } from 'lodash'
  import { API } from '@/utils/api'
  import { duplicatesFlags } from '@/utils/helper'
  import FilterTable from '@/components/report/filterTable.vue'
  import TotalCalculateSub from '@/components/report/TotalRows/TotalCalculateSub.vue'
  import TotalCalculateRows from '@/components/report/TotalRows/TotalCalculateRows.vue'
  import TotalFilteredRows from '@/components/report/TotalRows/TotalFilteredRows.vue'
  import { totalTableMixin } from '@/components/report/TotalRows/TotalTableMixin'
  import TotalTableInSelect from '@/components/report/TotalRows/TotalTableInSelect.vue'
  import { isSmallScreenLaptopMixin } from '@/components/report/Table/isSmallScreenLaptopMixin'
  import { filters } from '@/utils/filters'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'
  import Vue, { ref } from 'vue'
  import { socketUpdate } from '@/components/report/Table/socketUpdate'

  const enUS = 'en-US'
  const frFR = 'fr-FR'
  const deDE = 'de-DE'

  const FORMATTING_OPTIONS = [
    { text: 'Default (1234567.89)', value: 'default' },
    { text: 'Comma thousands (1,234,567.89)', value: enUS },
    { text: 'Space thousands (1 234 567,89)', value: frFR },
    { text: 'Dot thousands (1.234.567,89)', value: deDE },
  ]
  const LOCALE_FORMATTERS = {
    default: { format(v) { return v; } },
    [enUS]: new Intl.NumberFormat(enUS, { minimumFractionDigits: 0, maximumFractionDigits: 10 }),
    [frFR]: new Intl.NumberFormat(frFR, { minimumFractionDigits: 0, maximumFractionDigits: 10 }),
    [deDE]: new Intl.NumberFormat(deDE, { minimumFractionDigits: 0, maximumFractionDigits: 10 }),
  }
  const LS_FORMATTER_KEY = 'report-default:locale-formatter'

  export default {
    props: {
      title: {},
      headers: {},
      projectList: {
        default: () => ([])
      },
      filters: {},
      url: {},
      defaultParams: {
        default: () => ({})
      },
      nowrap: {
        default: true
      },
      table_size_fixed: {
        default: false
      },
      options: {
        default: () => ({})
      }
    },

    components: {
      SelectProject,
      DatePicker,
      TotalTableInSelect,
      TotalFilteredRows,
      TotalCalculateRows,
      TotalCalculateSub,
      FilterTable,
      Export: () => import('@/components/helper/Export')
    },
    inject: [ 'socket' ],
    mixins: [ totalTableMixin, isSmallScreenLaptopMixin, socketUpdate ],
    data: function () {
      return {
        itemsMap: new Map(),
        additionalItems: [],
        pausedItems: [],
        autoUpdate: -1,
        socketUpdateIcon: 'mdi-pause',

        totalItems: -1,
        tableOptions: {},
        iovationColorMap: {
          R: 'yellow lighten-4',
          D: 'red lighten-4',
          A: 'green lighten-4'
        },
        project: this.options.multiple ? [] : null,
        loading: false,
        loadingGames: false,
        brand_alias: null,
        system_alias: null,
        game_id: null,
        login: null,
        totalRow: false,
        typeCommission: [ 'external' ],
        totalRows: false,
        items: [],
        games: [],
        filtersD: {},
        isTotalExtendOpen: null,
        day: null,
        month: null,
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        dateRangeList,
        accountType: [ 'casino', 'sport' ],
        byCountry: false,
        expanded: false,
        subItems: {},
        filtersOfExpandedTable: {},
        FORMATTING_OPTIONS,
        localeFormatter: window.localStorage.getItem(LS_FORMATTER_KEY) ?? 'default',
      }
    },

    computed: {
      months () {
        return range(1, 13)
      },
      days () {
        if (this.month) {
          return range(1, (new Date((new Date().getFullYear()), this.month, 0).getDate() + 1))
        }
        return range(1, 32)
      },
      filteredFreespinsGames: function () {
        return filter(this.games, (o) => (o.system_alias == this.tableOptions.system_alias || !this.tableOptions.system_alias) && (o.brand_alias == this.tableOptions.brand_alias || !this.tableOptions.brand_alias))
      },
      providerBrandsAliases: function () {
        return map(this.tableOptions.system_alias ? filter(this.games, (o) => o.system_alias == this.tableOptions.system_alias) : this.games, 'brand_alias')
      },
      providerSystemsAliases: function () {
        return map(this.games, 'system_alias')
      },
      exportFields: function () {
        return map(this.headers, 'value')
      },
      filteredItems: function () {
        return filters(this.items, this.filtersD)
      },
      filteredTotalRows: function () {
        return this.totalRows?.filter?.(d => {
          return Object.keys(this.filtersD).every(f => {
            if (f != this.options?.totalCalculate?.subGroup) {
              return true
            }
            return (this.filtersD[f].data.length < 1 || (this.filtersD[f].data.includes(get(d, f)) || (get(d, f).toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
      filteredSubItems: function () {
        return filters(this.subItems[this.expanded].items, this.filtersOfExpandedTable)
      },
      socketAvailable: function () {
        return this.socket && this.options?.socketUpdate
      }
    },

    mounted () {
      this.project = this.projectList[0].value
      if (this.options.multiple) {
        this.project = this.options.multipleDefaultAllSelected ? [ ...this.$store.state.auth.entities ].map(entity => entity.entity_id) : [ this.projectList[0].value ]
      }

      if (this.options.birthday) {
        this.day = parseInt(moment().format('D'), 10)
        this.month = parseInt(moment().format('M'), 10)
      }
    },

    watch: {
      'additionalItems': {
        handler (additionalItems) {
          additionalItems.forEach(item => {
            this.itemsMap.set(item[this.options?.socketUpdate?.key], item)
          })
          this.items = Array.from(this.itemsMap.values())
        },
        deep: true,
        immediate: true
      },
      'options.expand': {
        handler () {
          this.filtersOfExpandedTable = this.options?.expand?.filters ?? {}
        },
        deep: true,
        immediate: true
      },
      month: function () {
        if (!this.day || !includes(this.days, this.day)) {
          this.day = 1
        }
      },
      project: function () {
        if (this.options.selectGame || this.options.selectSystemBrand) this.loadGames()
      },
      tableOptions: {
        handler () {
          if (this.options.pagination && this.totalItems != -1) {
            this.search()
          }
        },
        deep: true,
      },
      filters: {
        handler: debounce(function () {
          this.filtersD = this.filters
        }, 800),
        deep: true,
      },
    },

    methods: {
      fmtIntl(v) {
        return typeof v === 'number' ? LOCALE_FORMATTERS[this.localeFormatter].format(v) : v
      },
      round,
      get,

      duplicatesFlags,

      toggleSocketUpdate () {
        if (this.autoUpdate === -1) {
          return
        }

        this.autoUpdate = !this.autoUpdate
        this.socketUpdateIcon = this.autoUpdate ? 'mdi-pause' : 'mdi-play'

        if (this.socketAvailable) {
          this.additionalItems = [ ...this.pausedItems ]
          this.pausedItems = []
        }
      },

      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

      getTotalHeaderText: function (alias) {
        return find(this.headers, (o) => o.value === alias, {}).text
      },

      expandInit: function (init) {
        if (!init.value) return
        this.expanded = init.item.row_key

        for (let k in this.filtersOfExpandedTable) {
          this.filtersOfExpandedTable[k].data = []
        }

        this.searchExpanded(init.item)
      },

      searchExpanded (item) {
        let key = this.expanded
        if (!this.subItems[key]) {
          this.subItems[key] = Vue.observable({
            items: [],
            loading: false
          })
        }

        this.subItems[key].loading = true
        this.subItems[key].items = []

        return API.call(this.options.expand.url, {
          from: this.from,
          to: this.to,
          product_id: item.product_id,
          ...this.tableOptions
        }, null, isArray(this.project) ? this.project[0] : this.project).then(resp => {
          this.subItems[key].items = resp.data
          return resp.data
        }).finally(() => {
          this.subItems[key].loading = false
        })
      },

      loadGames () {
        this.loadingGames = true
        API.call('/$v/game/list.json', {}, null, this.project).then(resp => {
          this.games = resp.data
        }).catch(e => {
        }).finally(() => {
          this.loadingGames = false
        })
      },

      search: function () {
        this.loading = true
        try {
          if (this.options.accountType) {
            this.defaultParams.account_type = this.accountType
          }
          if (this.options.login) {
            this.defaultParams.login = this.login
          }

          if (this.options.multiple) {
            this.defaultParams.by_entities = this.project
          }

          if (this.options.birthday) {
            this.defaultParams.birthday = (this.day || '01') + '.' + (this.month || '01')
          }

          if (this.options.byCountry) {
            this.defaultParams.by_country = this.byCountry
          }

          this.autoUpdate = -1

          API.call(this.url, {
            from: this.from,
            to: this.to,
            ...this.defaultParams,
            ...this.tableOptions
          }, null, isArray(this.project) ? this.project[0] : this.project).then(resp => {

            this.items = get(resp, 'data', [])

            if (this.socket && this.options?.socketUpdate) {
              this.joinRooms()
            }

            this.itemsMap = ref(new Map())
            if (this.options?.socketUpdate?.key) {

              if (moment().format('YYYY-MM-DD') === this.to || moment().format('YYYY-MM-DD') === this.from) {
                this.autoUpdate = true
              }

              this.items.forEach(item => this.itemsMap.set(item[this.options?.socketUpdate?.key], item))
            }

            if (get(resp, 'pagination', false)) {
              this.totalItems = resp.pagination.total
            }
            if (get(resp, 'totalRow', false)) {
              this.totalRow = resp.totalRow
            }
            if (get(resp, 'totalRows', false)) {
              this.totalRows = resp.totalRows
            }

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        return this.items
          .map(d => get(d, val))
          .flatMap(item =>
            typeof item === 'string'
              ? item.split(',').map(i => i.trim())
              : []
          )
          .filter(i => i);
      },

      onLocaleFormatterChange(formatter) {
        this.localeFormatter = formatter
        localStorage.setItem(LS_FORMATTER_KEY, formatter)
      },
    },

    beforeDestroy () {
      this.leaveRooms()
    }
  }
</script>
